module.exports = require("update-notifier");


//////////////////
// WEBPACK FOOTER
// external "update-notifier"
// module id = 24
// module chunks = 0